function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25 5v20H5V5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M23 7H7v16h16z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 11v2h-2v4h2v2H9v-8h4zm8 0v8h-4v-2h2v-4h-2v-2h4z"
});

function SvgQFillInTheBlankTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default SvgQFillInTheBlankTypeIcon;